var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {

	}
};

site.boxmanSitemapEdit = {
	init: function() {
		$('body.page .boxmanSitemapEdit').appendTo($('#main > .box > .boxText > .jip').first());
	}
};

site.pageImage = {
	init:function() {
		$('label', '#elm_page_galleryImageId .lmnt').each(function() {
			var $this = $(this),
				url = $this.text();
			$this.html($this.html().replace(url, '<img alt="" src="//placehold.it/1" class="responsive" data-src="'+url+'" />'));
		});

		$('#page-tabs').on('tabsactivate', function(event, ui) {
			if (ui.newTab.index() == 3) {
				$("img.responsive").responsiveImg();
			}
		});
		window.addEventListener('load', function () {
			if (location.hash === "#pageImage") {
				$("img.responsive").responsiveImg();
			}
		});
		window.addEventListener("beforeunload", function (event) {
			if (tinyMCE.activeEditor.isDirty()) {
				// browser don't seem to be using this. They show a localized text based on browser language.
				var r = "You have unsaved content. Still want to leave";
				event.returnValue = r;
				return r;
			}
		});
	}
};

site.gallery = {
	init:function(r){
		var form = document.getElementById('imageNew');
		if (form && r) {
			var submit = form.querySelector('[type="submit"]');
			submit.id = '';
			submit.disabled = 0;
			submit.addEventListener('click', function(e) {
				e.preventDefault();
				window.location = r;
				return false;
			}, false);
		}
	}
};

site.boxman = {
	init: function () {
		$("#dialog").on("dialogopen", function (event, ui) {
			site.boxman.waitUntil(function () {
				return $('#title', '.boxmanBoxForm').length > 0;
			}, function () {
				site.empboxes.admin();
			}, function () {
			});
		});
	},
	waitUntil: function (isready, success, error, count, interval) {
		if (count === undefined) {
			count = 100;
		}
		if (interval === undefined) {
			interval = 20;
		}
		if (isready()) {
			success();
			return;
		}
		// The call back isn't ready. We need to wait for it
		setTimeout(function () {
			if (!count) {
				// We have run out of retries
				if (error !== undefined) {
					error();
				}
			} else {
				// Try again
				site.boxman.waitUntil(isready, success, error, count - 1, interval);
			}
		}, interval);
	}
};

site.navigation = {
	init: function() {
		var $menu = $('#mainmenu li.level1');
		$menu.mouseenter(function(e) {
			e.preventDefault();
			if ($(this).closest('.level1').is('.show')) {
				$('#mainmenu .level1').removeClass('show');
			} else {
				$('#mainmenu .level1').removeClass('show');
				$(this).closest('.level1').addClass('show');
				$('body').addClass('showMenu');
			}
		});

		$('#mainmenu li.level1').mouseleave(function(e) {
			if ($('body').is('.showMenu')) {
				$('#mainmenu .level1').removeClass('show');
				$(this).removeClass('showMenu');
			}
		});

		$('#mainmenu').click(function(e) {
			e.stopPropagation();
		});
	}
};

site.adHover = {
	init: function() {
		var $ads = $('body.forsida #box_group_1 .strevda li');
		// site.adHover.addSitemapTitles($ads);
		site.adHover.setupHoverEffect($ads);
	},

	addSitemapTitles: function($ads) {
		$ads.each(function() {
			var $this = $(this);
			var $url = $this.children('a').attr('href');
			var $title = $('#mainmenu').find("a[href='" + $url + "'] > span").text();
			$(this).find('.sitemap-title').text($title);
		});
	},

	setupHoverEffect: function($ads) {
		$(document).ready(function() {
			$ads.on('hover', function() {
				var $this = $(this);
				var $url = $this.children('a').attr('href');
				var $elem = $('#mainmenu').find("a[href='" + $url + "']").not('.parent').closest('li');
				$elem.toggleClass('forwardHover');
			});
		});
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

site.entryContent = {
	init:function() {
		var $boxText = $('.boxText', '#main');
		if (!$boxText) return false;

		$('li a', $boxText).each(function() {
			$(this).hover(function() {
				$(this).parents('li').toggleClass('hover');
			});
			var link = $(this).attr('href');
			if (link) {
				link = link.toLowerCase();
				if (link.indexOf('.pdf') > -1) {
					$(this).parents('li').addClass('pdf');
				} else if (link.indexOf('.doc') > -1) {
					$(this).parents('li').addClass('doc');
				} else if (link.indexOf('.xls') > -1) {
					$(this).parents('li').addClass('xls');
				} else if (link.indexOf('mailto:') > -1) {
					$(this).parents('li').addClass('mail');
				} else if (link.indexOf('tel:') > -1) {
					$(this).parents('li').addClass('tel');
				} else if (link.indexOf('facebook.com') > -1) {
					$(this).parents('li').addClass('facebook');
				} else if (link.indexOf('http') > -1) {
					$(this).parents('li').addClass('external');
				}
				$(this).parents('li').addClass('link');
			}
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.navigation.init();
	site.megamenu.init();
	site.adHover.init();
	site.entryContent.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.loggedIn')) {
		site.boxmanSitemapEdit.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
